var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-902.000000, -254.000000) translate(144.000000, 248.000000) translate(758.544304, 6.823529)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F9F9F9",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495171",
    d: "M12 7c.552 0 1 .448 1 1v7.538l2.299-2.271c.39-.418 1.021-.418 1.41.002.194.209.292.483.292.757 0 .23-.068.458-.204.65l-.09.11-2.3 2.274c-.627.674-1.465.985-2.287.935-.04.003-.08.005-.12.005-.04 0-.08-.002-.12-.007l-.078.005c-.797.027-1.601-.286-2.208-.938l-2.301-2.274-.09-.11c-.135-.192-.203-.42-.203-.65 0-.274.097-.548.291-.757.39-.42 1.02-.42 1.41-.002L11 15.538V8c0-.552.448-1 1-1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowDown);
export default __webpack_public_path__ + "static/media/sort-arrow-down.3455b6ee562fd294da5ac183cbc0c476.svg";
export { ForwardRef as ReactComponent };